export default __webpack_public_path__ + "static/media/foto2.70c56213.jpg";